import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Box,
  CircularProgress,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";

const FAQList = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);
  const navigate = useNavigate();

  const fetchFAQs = async () => {
    try {
      const response = await api.getFAQs();
      if (response?.status === 200 && Array.isArray(response.data)) {
        setFaqs(response.data);
      }
    } catch (err) {
      console.error("Failed to fetch FAQs", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const confirm = window.confirm("Are you sure you want to delete this FAQ?");
      if (!confirm) return;

      const res = await api.deletFAQ(id);
      if (res.status === 200) {
        setFaqs((prev) => prev.filter((item) => item.id !== id));
      }
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  const handleAccordionChange = (panelId) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : null);
  };

  useEffect(() => {
    fetchFAQs();
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Typography variant="h4" fontWeight="bold">
          Manage FAQs
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/settings/addFAQ")}
        >
          Add FAQ
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : faqs?.length > 0 ? (
        faqs.map((item) => (
          <Accordion
            key={item.id}
            expanded={expanded === item.id}
            onChange={handleAccordionChange(item.id)}
            sx={{ mb: 2 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ flexGrow: 1, fontWeight: "bold" }}>
                {item.question}
              </Typography>
              <IconButton onClick={(e) => {
                e.stopPropagation();
                handleDelete(item.id);
              }}>
                <DeleteIcon color="error" />
              </IconButton>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <Typography>No FAQs found.</Typography>
      )}
    </Container>
  );
};

export default FAQList;
